import { z } from 'zod';

const email = z.string().min(1, 'Vul een e-mailadres in').email('Voer een geldig e-mailadres in');

const fullName = z
  .string()
  .min(1, 'Vul je volledige naam in')
  .min(2, 'Naam moet minimaal 2 tekens bevatten')
  .transform((val) => val.trim());

const telephone = z
  .string()
  .transform((val) => val.trim())
  .pipe(z.string().regex(/^(\+?\d[\d\s\-()]*)?$/, 'Voer een geldig telefoonnummer in'))
  .default('');

const otp = z
  .string()
  .length(6, 'Voer een 6-cijferige code in')
  .regex(/^\d{6}$/, 'Code mag alleen cijfers bevatten');

export const loginEmailSchema = z.object({ email });

export const registrationSchema = z.object({ email, fullName, telephone });

export const otpSchema = z.object({ otp });

export const profileSchema = z.object({ fullName, telephone });
